/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { keysRevokeById } from "../funcs/keysRevokeById.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RevokeAPIKeyRequest,
  RevokeAPIKeySecurity,
} from "../models/operations/revokeapikey.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RevokeAPIKeyMutationVariables = {
  request: RevokeAPIKeyRequest;
  security?: RevokeAPIKeySecurity | undefined;
  options?: RequestOptions;
};

export type RevokeAPIKeyMutationData = void;

export type RevokeAPIKeyMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * revokeKey keys
 *
 * @remarks
 * Revoke a api key
 */
export function useRevokeAPIKeyMutation(
  options?: MutationHookOptions<
    RevokeAPIKeyMutationData,
    RevokeAPIKeyMutationError,
    RevokeAPIKeyMutationVariables
  >,
): UseMutationResult<
  RevokeAPIKeyMutationData,
  RevokeAPIKeyMutationError,
  RevokeAPIKeyMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRevokeAPIKeyMutation(client, options),
    ...options,
  });
}

export function mutationKeyRevokeAPIKey(): MutationKey {
  return ["@gram/client", "keys", "revokeById"];
}

export function buildRevokeAPIKeyMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RevokeAPIKeyMutationVariables,
  ) => Promise<RevokeAPIKeyMutationData>;
} {
  return {
    mutationKey: mutationKeyRevokeAPIKey(),
    mutationFn: function revokeAPIKeyMutationFn({
      request,
      security,
      options,
    }): Promise<RevokeAPIKeyMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(keysRevokeById(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
